import {HttpClient, HttpEventType} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {distinct, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {IProgressResponse, IUploadFilesService} from '../../../contract-control/modals/bulk-upload-modal/upload-files.service';


@Injectable({
    providedIn: 'root'
})
export class DocumentUploadFileApiService implements IUploadFilesService {

    constructor(protected httpClient: HttpClient) {
    }

    uploadFile<T, P>(file, requestParams: P): Observable<IProgressResponse<T>> {

        const formData = new FormData();

        formData.append('file', file);
        formData.append('document_type_id', (<{document_type_id:number}>requestParams).document_type_id.toString());

        const categoryIds = (<{category_ids:number[]}>requestParams).category_ids;
        if (categoryIds && categoryIds.length > 0) {
            categoryIds.forEach(id => {
                formData.append('category_ids[]', id.toString());
            });
        }
        return this.httpClient.post(`documents/upload`, formData, {
            observe: 'events', reportProgress: true
        })
            .pipe(distinct(), map(event => {
                switch (event.type) {
                    case HttpEventType.Sent:
                        return {
                            percent: 0, file: file
                        } as IProgressResponse<T>;
                    case HttpEventType.UploadProgress: {
                        return {
                            percent: event.total ? Math.round(100 * event.loaded  / event.total) : 0, file: file
                        } as IProgressResponse<T>;
                    }

                    case HttpEventType.Response: {
                        return {
                            percent: 100, response: event.body, file: file
                        } as IProgressResponse<T>;
                    }

                }
                return {
                    file: file, percent: 0
                } as IProgressResponse<T>;
            }));

    }
}
